import {Component, ComponentFactoryResolver, OnInit} from '@angular/core';
import {ContentScope, PlatformCommand} from '@shared/commands/command-base';
import {Configuration} from '@shared/models/configuration';
import {ActivatedRoute, Router} from '@angular/router';
import {take, takeUntil} from 'rxjs/operators';
import {CommandService} from '@core/services/command.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {PlatformQuery, PlatformQueryResponse} from '@shared/models/platform-query/platform-query';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {SecurityState} from '@shared/store/reducers/security.reducer';
import {select, Store} from '@ngrx/store';
import {getUserInfo} from '@shared/store/selectors/security.selector';
import {UserInfo} from '@shared/models/user-info.model';
import {Subject} from 'rxjs';
import {SnackBarService} from '@core/services/snack-bar.service';
@Component({
    standalone: false,
    selector: 'app-view-analytics-eat-workflow',
  templateUrl: './view-analytics-eat-workflow.component.html',
  styleUrls: ['./view-analytics-eat-workflow.component.scss']
})
export class ViewAnalyticsEatWorkflowComponent implements OnInit {
  private flowId: string;
  invalidateSubject = new InvalidateSubject();
  private conversationId: string;
  private queryResponse: PlatformQueryResponse;
  private participants: any;
  private currentUser: UserInfo;
  public unsubscribe$ = new Subject<void>();
  constructor(private activatedRoute: ActivatedRoute,
              private commandService: CommandService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private platformQueryService: PlatformQueryService,
              private componentFactoryResolver: ComponentFactoryResolver,
              private dialogService: DialogService,
              private router: Router,
              private snackbarService: SnackBarService,
              public securityStore: Store<SecurityState>,
              ) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.conversationId = params['conversationId'];
    });
    this.activatedRoute.params.subscribe(res => {
      this.flowId = res.flowId;
    });
    this.securityStore.pipe(select(getUserInfo)).pipe(takeUntil(this.unsubscribe$)).subscribe(currentUser => {
      this.currentUser = currentUser;
    if (this.currentUser) {
      const participantsQuery = new PlatformQuery();
      participantsQuery.api = 'VisualizerApi';
      participantsQuery.name = 'GetEatParticipantsByFlowIdQuery';
      participantsQuery.fieldValues['ExecutionId'] = this.flowId;
      if (this.conversationId) {
        participantsQuery.fieldValues['ConversationId'] = this.conversationId;
      }
      const navigationCommand = new PlatformCommand('NavigateToWorkflowCommand', 'FlowApi');
      navigationCommand.fieldValues['FlowId'] = this.flowId;
      if (this.conversationId) {
        navigationCommand.fieldValues['ConversationId'] = this.conversationId;
        this.platformQueryService.executeQuery(participantsQuery).pipe(take(1)).subscribe(queryResponse => {
          this.queryResponse = queryResponse;
          // todo
          if (this.queryResponse.fieldValues['DataItems']) {
            this.participants = queryResponse.fieldValues['DataItems'];
            this.participants = this.participants.filter(o => o.id !== this.currentUser.email);
            const dialogModel = DialogModel.create('Select Participants', 'ParticipantsCheckboxSelectorComponent', {
              invalidateSubject: this.invalidateSubject,
              participantsList: this.participants
            });
            // dialogModel.componentFactoryResolver = this.componentFactoryResolver;
            dialogModel.maxWidth = '800px';
            dialogModel.minWidth = '800px';
            if (this.participants.length >= 1) {
              this.dialogService.showOkCancelDialog(dialogModel).subscribe(state => {
                if (state.action === 'OK') {
                  if (state.data.input.participantsList) {
                    navigationCommand.fieldValues['DataItems'] = state.data.input.participantsList;
                  }
                  this.commandService.executePlatformCommand(navigationCommand).pipe(take(1)).subscribe(commandResponse => {
                      console.log('Command Response', commandResponse);
                      this.fuseSplashScreenService.hide();
                      if (commandResponse.fieldValues['RedirectUrl']) {
                        this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
                      }
                      this.invalidateSubject.invalidate();
                    },
                    error => {
                      console.error('Failed ToolBarComponent command', error);
                      this.fuseSplashScreenService.hide();
                    });
                }
              });
            } else {
              this.commandService.executePlatformCommand(navigationCommand).pipe(take(1)).subscribe(commandResponse => {
                  console.log('Command Response', commandResponse);
                  this.fuseSplashScreenService.hide();
                  if (commandResponse.fieldValues['RedirectUrl']) {
                    this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
                  }
                  this.invalidateSubject.invalidate();
                  this.snackbarService.showInformation('No new participants found in the workflow nodes for creating conversation. ');
                },
                error => {
                  console.error('Failed ToolBarComponent command', error);
                  this.fuseSplashScreenService.hide();
                });
            }
          }
        });
      } else {
        this.commandService.executePlatformCommand(navigationCommand).pipe(take(1)).subscribe(commandResponse => {
            console.log('Command Response', commandResponse);
            this.fuseSplashScreenService.hide();
            if (commandResponse.fieldValues['RedirectUrl']) {
              this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
            }
            this.invalidateSubject.invalidate();
          },
          error => {
            console.error('Failed ToolBarComponent command', error);
            this.fuseSplashScreenService.hide();
          });
      }
    }
    });
  }
}
